import { Badge } from "@radix-ui/themes";
import { TopicBadge as TopicBadgeType } from "./TopicsList.types";

export const TopicBadge = ({ badge }: { badge: TopicBadgeType }) => (
  <Badge
    color={badge.color}
    size="1"
    style={
      badge.type === "live"
        ? {
            color: "var(--green-11)",
            backgroundColor: "var(--green-3)",
          }
        : undefined
    }
  >
    {badge.label}
  </Badge>
);
